// extracted by mini-css-extract-plugin
module.exports = {"inner":"SamplesFilterDesktopForm_inner__8J2uC","wrapper":"SamplesFilterDesktopForm_wrapper__QJ87B","unitTabs":"SamplesFilterDesktopForm_unitTabs__Sa1DM"};